@if (realmData != null) {
    <div class="PGRealmCard">
        <div class="row">
            @if (realmData.logo) {
                <div class="col-12 col-md PGRealmCard-Logo">
                    <div class="rounded">
                        <app-pg-image-autosize [src]="realmData.logo" fit="{{getImageFit()}}"></app-pg-image-autosize>
                    </div>
                    <div class="pb-3 d-md-none"></div>
                </div>
            }
            <div class="PGRealmCard-Text text-start col d-flex flex-column justify-content-center">
                <h3 class="mb-0">{{realmName}}</h3>
                @if(realmData.website) {
                    <div class="mt-1">
                        <i class="fa-regular fa-globe me-2 text-muted"></i>
                        <a target="_blank" href="{{realmData.website}}">{{realmData.website}}</a>
                    </div>
                }
                @if (realmData.contacts != null && realmData.contacts.length > 0) {
                    <div class="PGRealmCard-Text-Contacts mt-1">
                        @for (contact of realmData.contacts; track contact; let i = $index) {
                            <div class="mt-2 PGRealmCard-Text-Contacts-Item">
                                <div>
                                    @if (contact.name) {
                                        <div class="PGRealmCard-Text-Contacts-Item-Name">{{contact.name}}</div>
                                    }
                                    @if (contact.description) {
                                        <div class="text-muted PGRealmCard-Text-Contacts-Item-Description">{{contact.description}}</div>
                                    }
                                </div>
                                @if (contact.email || contact.phone || contact.website) {
                                    <div class="PGRealmCard-Text-Contacts-Item-Values">
                                        @if (contact.email) {
                                            <div>
                                                <a href="mailto:{{contact.email}}">{{contact.email}}</a>
                                            </div>
                                        }
                                        @if (contact.phone) {
                                            <div>
                                                <a href="phone:{{contact.phone}}">{{contact.phone}}</a>
                                            </div>
                                        }
                                        @if (contact.website) {
                                            <div>
                                                <a target="_blank" href="{{contact.website}}">{{contact.website}}</a>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
}
